/**
 * Parameter key definitions for analytics events
 * Matches iOS AnalyticsParameters.swift exactly
 */

/**
 * Standard parameter keys used across all analytics events
 */
export const AnalyticsParameters = {
  // MARK: - Standard Parameters (Always Include)
  platform: 'platform',
  appVersion: 'app_version',
  userId: 'user_id',
  sessionId: 'session_id',
  timestamp: 'timestamp',
  eventVersion: 'event_version',

  // MARK: - Screen Parameters
  screenName: 'screen_name',
  screenClass: 'screen_class',

  // MARK: - Action Parameters
  buttonName: 'button_name',
  buttonLocation: 'button_location',

  // MARK: - Error Parameters
  errorCode: 'error_code',
  errorMessage: 'error_message',

  languageName: 'language_name',
  prevLanguageCode: 'prev_language_code',
  languageCode: 'language_code',

  // MARK: - Store Parameters
  storeId: 'store_id',
  storeName: 'store_name',
  previousStoreId: 'previous_store_id',
  apiEndpoint: 'api_endpoint',

  // MARK: - Site Parameters
  siteId: 'site_id',
  partyId: 'party_id',
  searchResultsCount: 'search_results_count',
  sortOption: 'sort_option',
  filterOption: 'filter_option',

  // MARK: - Challan Parameters
  challanId: 'challan_id',
  entryId: 'entry_id',
  entryType: 'entry_type',
  rateType: 'rate_type',
  entryTypeFilter: 'entry_type_filter',

  // MARK: - List
  loadTrigger: 'load_trigger',
  result: 'result',
  itemCount: 'item_count',
  listName: 'list_name',

  entityType: 'entity_type',
  entityId: 'entity_id',

  // MARK: - Auth Parameters
  loginMethod: 'login_method',
  isFirstLogin: 'is_first_login',
} as const
